import * as angular from "angular";

export class ExportService {
    private readonly apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/export";
    }

    all(): Promise<object> {
        return this.$http.get(this.apiRoot + "/all");
    }

    canvasses(data: object): Promise<object> {
        return this.$http.get(this.apiRoot + "/canvasses", { params: data });
    }

    create(data: object): Promise<object> {
        return this.$http.post(this.apiRoot + "/create", data);
    }

    walkingList(data: object): Promise<object> {
        return this.$http.post(this.apiRoot + "/walkinglist", data);
    }

    geoJson(data: object): Promise<object> {
        // Laravel endpoint (relative /v2 path), not the Restler API host
        return this.$http.post("/v2/group/geojson/export", data);
    }

    kml(data: object): Promise<object> {
        // Laravel endpoint (relative /v2 path), not the Restler API host
        return this.$http.post("/v2/group/kml/export", data);
    }

    shapefile(data: object): Promise<object> {
        // Laravel endpoint (relative /v2 path), not the Restler API host
        return this.$http.post("/v2/group/shapefile/export", data);
    }
}

angular.module("vcServices").service("ExportService", ExportService);
